import { render, staticRenderFns } from "./FirstNolaOnboarding.vue?vue&type=template&id=2de96188"
import script from "./FirstNolaOnboarding.vue?vue&type=script&lang=ts"
export * from "./FirstNolaOnboarding.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports